module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/blog/walmart-amazon-take/walmart-amazon-take.component.scss
// module id = 763
// module chunks = 0